import React from 'react';
import { motion } from 'framer-motion';

const tabs = ["Publications", "Liked", "Events", "Effects"];

interface ProfileNavProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const ProfileNav: React.FC<ProfileNavProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className="sticky top-0 z-10 bg-gray-900 border-b border-gray-700">
      <nav className="flex justify-center space-x-4 md:space-x-8">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`${
              activeTab === tab ? 'text-white' : 'text-gray-400'
            } relative py-4 px-2 md:px-4 text-sm md:text-base font-medium transition-colors hover:text-white`}
          >
            {tab}
            {activeTab === tab && (
              <motion.div
                className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-500"
                layoutId="underline"
              />
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default ProfileNav;
